module.exports = __webpack_public_path__ + "img/ANTENNA RADIO RED.4a601c2.svg";